module.exports = __webpack_public_path__ + "static/media/MobilePhoneApple-nz.4c91beec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MobilePhoneApple-nz.png
// module id = 6122
// module chunks = 1